import React from "react";
import { UserLinkAndPostTime } from "./UserLinkAndPostTime";
import SocialPublishingStatus from "./SocialPublishingStatus";

export default function PostHeader({ post, pageName }) {
  return (
    <div className={"conversation-item-post-header"}>
      <UserLinkAndPostTime post={post} pageName={pageName} />
    </div>
  );
}
